export enum Colors {
  orange = '#F79D1EB3',
  red = '#DB2F23B3',
  green = '#8DCC21B3',
  gray = 'gray',
  yellow = '#f0d92bb3',
  blue = '#1A5BE8B3',
  stripes = 'linear-gradient(45deg, #808080 25%, #ababab 25%, #ababab 50%, #808080 50%, #808080 75%, #ababab 75%, #ababab 100%)',
  white = '#FFFFFF',
}
